const PREFIX = { IDENT: 'identity', AUTH: 'authentication', AC: 'accessControl', APP: 'applications', MON: 'monitoring' };

/** The category key (the keys of securityPosture.categories) of a check id such as AUTH-001. */
export function categoryOfFinding(id) {
  const prefix = String(id ?? '').split('-')[0];
  return Object.prototype.hasOwnProperty.call(PREFIX, prefix) ? PREFIX[prefix] : null;
}

/** Sentence-case area names for the category keys (ENTRAID-347 redesign: "and", never "&"). */
export const AREA_LABELS = Object.freeze({
  identity: 'Identity and accounts',
  authentication: 'Authentication',
  accessControl: 'Access control',
  applications: 'Applications and permissions',
  monitoring: 'Monitoring and risk',
});
